module.exports = __webpack_public_path__ + "img/onion.be5030ca.webp";